'use client';

import { createContext } from 'react';
import { GlobalContextType } from '@/types/context';

export const GlobalContext = createContext<GlobalContextType>({});
